/**
 * 企画回別商品一覧画面の注文コード割当コードクラス
 *
 * @export OrderNumQuota
 * @class OrderNumQuota
 */
export class OrderNumQuota {
  constructor(
    public orderNumQuotaCode: string,
    public orderNumQuotaName: string,
    public delivCatalogID: string,
    public deliveryWeekFixFlag: string,
    public orderNumQuotaCodeName: string,
    public orderNumQuotaLabel: string // ラベル格納用
  ) {}
}
